<template>
<!-- eslint-disable -->
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 1773.7 439.7"
    style="enable-background:new 0 0 1773.7 439.7;"
    xml:space="preserve"
  >
    <g id="Warstwa_2"></g>
    <g id="Warstwa_1">
      <g>
        <g>
          <path
            class="st0"
            d="M103.7,161.9v15.6h71.4V226h-69.5V435H44.9V226H2.2v-48.6h42.8v-16.5c0-27.9,8.1-49.8,24.3-65.8
          c16.2-16,39-24.1,68.5-24.1c23.3,0,41.6,4.7,54.9,14.1l-17,45.7c-10.4-7.1-21.5-10.7-33.5-10.7
          C116.5,120.1,103.7,134,103.7,161.9z"
          ></path>
          <path
            class="st0"
            d="M221.3,421.4C200.3,410,183.8,394.2,172,374c-11.8-20.2-17.7-43.2-17.7-68.8c0-25.6,5.9-48.4,17.7-68.5
          c11.8-20.1,28.3-35.8,49.3-47.1c21-11.3,44.7-17,70.9-17c26.6,0,50.4,5.7,71.4,17c21,11.3,37.5,27.1,49.3,47.1
          c11.8,20.1,17.7,42.9,17.7,68.5c0,25.6-5.9,48.5-17.7,68.8c-11.8,20.2-28.3,36-49.3,47.4c-21.1,11.3-44.9,17-71.4,17
          C266,438.4,242.4,432.7,221.3,421.4z M347.6,364c14.6-14.9,21.9-34.5,21.9-58.8s-7.3-43.9-21.9-58.8
          c-14.6-14.9-33-22.3-55.4-22.3c-22.4,0-40.7,7.5-55.2,22.3c-14.4,14.9-21.6,34.5-21.6,58.8s7.2,43.9,21.6,58.8
          c14.4,14.9,32.8,22.4,55.2,22.4S333.1,378.9,347.6,364z"
          ></path>
          <path class="st0" d="M452.6,74.4h60.7V435h-60.7V74.4z"></path>
          <path class="st0" d="M556.6,74.4h60.7V435h-60.7V74.4z"></path>
          <path
            class="st0"
            d="M706.2,421.4c-21.1-11.3-37.5-27.1-49.3-47.4c-11.8-20.2-17.7-43.2-17.7-68.8c0-25.6,5.9-48.4,17.7-68.5
          c11.8-20.1,28.3-35.8,49.3-47.1c21-11.3,44.7-17,70.9-17c26.6,0,50.4,5.7,71.4,17c21,11.3,37.5,27.1,49.3,47.1
          c11.8,20.1,17.7,42.9,17.7,68.5c0,25.6-5.9,48.5-17.7,68.8c-11.8,20.2-28.3,36-49.3,47.4c-21.1,11.3-44.9,17-71.4,17
          C750.9,438.4,727.3,432.7,706.2,421.4z M832.6,364c14.6-14.9,21.9-34.5,21.9-58.8s-7.3-43.9-21.9-58.8
          c-14.6-14.9-33-22.3-55.4-22.3c-22.4,0-40.7,7.5-55.2,22.3c-14.4,14.9-21.6,34.5-21.6,58.8s7.2,43.9,21.6,58.8
          c14.4,14.9,32.8,22.4,55.2,22.4C799.5,386.4,818,378.9,832.6,364z"
          ></path>
          <path
            class="st0"
            d="M1335,175.5L1239.3,435H1181l-67.1-178.8l-68,178.8h-58.3l-95.2-259.5h57.3l68.5,191.5l71.4-191.5h51
          l70,192.4l70.5-192.4L1335,175.5L1335,175.5z"
          ></path>
        </g>
      </g>
      <g>
        <g id="p">
          <path
            class="st0"
            d="M1756.5,209.9c-8.8-14.4-21.3-25.6-37.5-33.4c-16.2-7.8-35.3-11.8-57.4-11.8h-29.6c0,0,0,100.4,0,135.7
          c0,26.4-7,44.5-12.7,56.9h42.3c22,0,41.1-3.9,57.4-11.6c16.2-7.7,28.7-18.9,37.5-33.4c8.8-14.6,13.1-31.6,13.1-51.1
          C1769.6,241.4,1765.2,224.3,1756.5,209.9z M1672.7,298.2L1672.7,298.2C1672.7,298.2,1672.7,298.2,1672.7,298.2L1672.7,298.2
          c-0.3-0.4-6.9-7.6-14.9-19.2c-12.2-17.7-12.2-24.9-10.9-32.5c3.1-18,20.6-19.1,27.7-17.1c9.6,2.7,13.4,10.7,13.8,11.7
          c0.9-0.7,8.1-5.6,17.9-3.1c7.1,1.8,20.7,10.4,15.3,28.7c-1.3,4.3-4.9,13.9-25.8,22.6"
          ></path>
          <path
            class="st0"
            d="M1587,405.8c-11.2,11.1-24.1,20.2-38.8,27.1h65.3v-64.5C1606.7,382.5,1597.8,395,1587,405.8z"
          ></path>
        </g>

        <linearGradient
          id="u2_1_"
          gradientUnits="userSpaceOnUse"
          x1="1505.1317"
          y1="53.2517"
          x2="1586.3722"
          y2="365.0839"
          gradientTransform="matrix(1 0 0 -1 0 442)"
        >
          <stop offset="0" style="stop-color:#3670CE"></stop>
          <stop offset="1" style="stop-color:#20E4BF"></stop>
        </linearGradient>
        <path
          id="u2"
          class="st1"
          d="M1637.2,97.6l-16.4-7.2v193.2c0,48.2-13.1,85.3-39.2,111.3c-26.1,26-62.7,39-109.7,39
        c-27,0-50.6-4.3-70.8-13c9.7,2.7,19.8,4.1,30.3,4.1c62.3,0,112.6-50.5,112.6-112.9c0-2.5,0.6-4.9,0.7-7.3
        c0.3-7.4,0.5-15.4,0.5-24.1l0.4-190.4l-17.3,7.2c0,0,21.1-38.4,28.1-51.2c6.6-12,26.4-48,26.4-48l25.9,47.2L1637.2,97.6z"
        ></path>
        <path
          id="u1"
          class="st0"
          d="M1544.5,312.2c0,62.3-50.7,112.9-113.1,112.9c-10.5,0-20.7-1.4-30.3-4.1c-14.8-6.3-27.8-15-38.9-26
        c-26.1-26-34.8-63.1-34.8-111.3l0,0c0-45.2,14.2-107.8,14.2-107.8l21.1,0l36.4-0.3c0,0-4.9,78.8-5.6,105.2
        c-1.6,58.8,30,88.3,78.8,88.3c23.8,0,42-7.1,54.5-21.4c16.3-18.7,17.7-42.8,17.7-42.8S1544.5,309.7,1544.5,312.2z"
        ></path>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'FollowUPLogotype'
};
</script>

<style scoped>
svg {
  height: 48px;
}

.st0 {
  fill: #fff;
}

.st1 {
  fill: url(#u2_1_);
}

</style>
